export default "__VITE_ASSET__DHmJg9Zn__"